"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
const react_1 = __importDefault(require("react"));
exports.Overlay = ({ show, title, description, children }) => {
    if (!show) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "overlay" },
        title ? react_1.default.createElement("div", { className: "overlay__title" }, title) : null,
        description ? react_1.default.createElement("div", { className: "overlay__description" }, description) : null,
        children));
};
//# sourceMappingURL=Overlay.js.map